/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_proximity.js                                                                         */
/**********************************************************************************************************************/
/* Controller.Reachability */

HafasWebapp.prototype.Controller.Reachability = {
  index: function (data) {
    Hafas.ps.pub('/options/gui/close/groups', [{}]);
    try {
      if (Hafas.Config.Switches.useFavorites) {
        this.Controller.Favorites.instance.checkDataConsistency();
        // getData(1): alle locations, die nicht vom Typ 1 (Station) sind,
        // erhalten den Wert display = false. Auf diesen wird im Template common.tabs.html gepr�ft
        var favorites = this.Controller.Favorites.instance.getData();
      }

      if (Hafas.Modules.History)
        Hafas.Modules.History.addData("Reachability", "index", {});

      var model = {

      };


      var useFavorites = Hafas.Config.Switches.useFavorites;
      model.customerOptions = this.Controller.Reachability.options.get();
      model.customerFavorites = useFavorites ? this.Controller.Favorites.instance.getData() : null;
      model.useOptions = Hafas.Config.Reachability.useQueryOptions;

      model.useDateTimePicker = Hafas.Config.Reachability.useDateTimePicker;
      var tmpLocation = this.Controller.Reachability.instance.getLocation();
      if (tmpLocation) {
        model.stationInput = tmpLocation.name;
      }

      model.travelPeriods = [
        {
          value: 30,
          label: Hafas.Modules.i18n.get('Proximity.t_N_PeriodValue', {value: 30})
        },
        {
          value: 60,
          label: Hafas.Modules.i18n.get('Proximity.t_N_PeriodValue', {value: 60})
        },
        {
          value: 120,
          label: Hafas.Modules.i18n.get('Proximity.t_N_PeriodValue', {value: 120})
        }
      ];
      for (var p = 0; p < model.travelPeriods.length; p++) {
        var tmpPeriod = model.travelPeriods[p];
        if (tmpPeriod.value == this.Controller.Reachability.instance.getPeriod()) {
          tmpPeriod.selected = true;
        }
      }

      var me = this;
      Hafas.Core.newType("hafasLoader", {
        file: 'reachability.index.html',
        tplId: 'Reachability_TplIndex',
        callback: function (templateId) {
          var master = templateId;

          Hafas.Modules.Render.render({
            target: me.formContainer,
            template: master,
            model: model
          }, function () {
            // Lade eventuell ge�nderte Optionen in die Formular-GUI
            Hafas.ps.pub('/options/setChangedOptionsInputForm');

            Hafas.ps.pub('/options/init', [{context: "Reachability"}]);

            me.Controller.Reachability.inpStation = Hafas.Core.newType('hafasSuggest', {
              loc: "ReachabilityLocation",
              config: Hafas.Config.Suggest,
              type: "S"
            });

            var _timeObj = Hafas.Core.newType("hafasTime", {
              date: me.Controller.SQ.instance.getDate(),
              time: me.Controller.SQ.instance.getTime()
            });

            // setting tdp-configuration
            if (Hafas.Config.Reachability.useDateTimePicker) {
              var dateTimePickerConfig = {
                holder: "HFS_ReachabilityDateTimePickerHolder",
                id: "ReachabilityDTP",
                config: {
                  useDepArrSwitch: false
                },
                current: {
                  date: me.Controller.Reachability.instance.getRequestDate(),
                  time: me.Controller.Reachability.instance.getRequestTime()
                }
              };
              me.Controller.Reachability.dateTimePicker = Hafas.Core.newType('hafasTimeDatePicker', dateTimePickerConfig);
              me.Controller.Reachability.instance.setTimeNow(true);
            } else {
              me.Controller.Reachability.instance.setTimeNow(false);
            }

            me.Controller.Reachability.travelPeriod = Hafas.Core.newType('HafasSelectBox', {holder: 'HFS_ReachabilityTravelPeriod_Holder', callback: function(data){
                Hafas.ps.pub('/reachability/changePeriod',[data.value]);
            }}).initiate();


            // Calculate slider values that can be selected
            var proxCfg = Hafas.Config.Reachability;

            var sliderSteps = 10;
            var stepArray = [];
            for (var s = proxCfg.minJourneyDuration; s <= proxCfg.maxJourneyDuration; s += sliderSteps) {
              var showMarker = false;
              var showLabel = false;
              var last = false;
              if(s == proxCfg.minJourneyDuration || s == proxCfg.maxJourneyDuration){
                showMarker = true;
                showLabel = true;
              }
              if(s == proxCfg.maxJourneyDuration){
                last = true;
              }
              var stepObj = {
                value: s,
                label: s.toString(),
                a11y: {
                  label: s.toString() + ' ' + Hafas.Modules.i18n.get('Reachability.t_N_Minutes')
                },
                showMarker: showMarker,
                showLabel: showLabel,
                last: last
              };
              if(s == me.Controller.Reachability.instance.getTravelTime()){
                 stepObj.type = 'handle';
              }
              stepArray.push(stepObj);
            }


            Hafas.ps.pub('/GUI/form/show', [{}]);

            var id = 'HFS_ReachabilityMaxJnyTimeSlider';

            var sliderDataModelOneHandle = {};

            sliderDataModelOneHandle.initialTemplates = [];
            // Modell zum Rendern
            sliderDataModelOneHandle.render           = {
              target  : id,
              template: 'Common_AtomTplSlider',
              file    : 'common.input_slider.html',
              model   : {
                // Slider Id
                id        : id,
                values    : stepArray
              }
            };

            // Modell zum erstellen des JavaScript Typs: HafasRangeSlider
            sliderDataModelOneHandle.newType = {
              holder  : sliderDataModelOneHandle.render.target,
              values  : sliderDataModelOneHandle.render.model.values,
              callback: function (data) {
                var currData = stepArray[data.activeMinIndex];
                if(typeof currData != 'undefined'){
                   me.Controller.Reachability.instance.setTravelTime(currData.value);
                }
              }
            };

            var reachLoc = me.Controller.Reachability.instance.getLocation();
            if(reachLoc != null) {
              Hafas('#ReachabilityLocation', false).value = reachLoc.name;
            }


            Hafas.Modules.Render.render(sliderDataModelOneHandle.render, function () {
              Hafas.Core.newType("HafasRangeSlider", sliderDataModelOneHandle.newType).initiate();
              Hafas.ps.pub('/app/events/resize');
            });

            // Favoriten als SegmentedControl
            if(Hafas.Config.showFavoriteBox === true) {
              Hafas.Core.newType('HafasSegmentedControl', {holder: 'HFS_CustomerFavoritesWrap'}).initiate();
            }

            Hafas.ps.pub('/app/contextLoaded/' + me.appContext);
            Hafas.ps.pub('/favorites/update');
            Hafas.ps.pub('/app/events/resize');
            Hafas.ps.pub('/tracking/screen/proximity-planner-main');
          });

          //   }
          // });
        }
      });
    } catch (e) {
      console.log(e);
    }
  },
  selectDateTimeFromPicker: function (hciDate, hciTime, enquiry, nowMode) {
    this.Controller.Reachability.instance.setRequestTime(hciTime);
    this.Controller.Reachability.instance.setRequestDate(hciDate);
    this.Controller.Reachability.instance.setTimeNow(nowMode);
  },
  setDate: function (hcidate) {
    this.Controller.Reachability.instance.setRequestDate(hcidate);
    this.Controller.Reachability.dateTimePicker.setDate(hcidate);
    this.Controller.Reachability.dateTimePicker.updateDisplay();
  },
  setTime: function (hcitime) {
    this.Controller.Reachability.instance.setRequestTime(hcitime);
    this.Controller.Reachability.dateTimePicker.setTime(hcitime);
    this.Controller.Reachability.dateTimePicker.updateDisplay();
  },
  postForm: function (data) {
    try {
      if (typeof data.ev != 'undefined')
        data.ev.preventDefault();
      var me = this;

      this.Controller.Reachability.validate(['ReachabilityLocation'], Hafas.bind(function () {
        var form = Hafas.Core.newType("hafasValidation", {
          form: data.form
        });
        Hafas.ps.pub('/app/events/resize');
        if (form.valid) {
          Hafas.bind(this.Controller.Reachability.startSearch, this)(data);

          // Track
          Hafas.ps.pub('/tracking/event/proximity-request', ['[' + me.appContext + '] FOR: ' + data.form.elements.ReachabilityLocation.value]);
        }
      }, this));
    } catch (e) {
      console.log(e);
    }
  },
  validate: function (data, callback) {
    var location = this.main.Controller.Reachability.instance.getLocation();
    if (this.main.Controller.Reachability.inpStation.getInputText().length == 0) {
      this.main.Controller.Reachability.instance.setLocation(null);
    }
    if ((this.main.Controller.Reachability.inpStation.getInputText().length > 0) && ((location == null) || (this.main.Controller.Reachability.inpStation.getInputText() != location.name))) {
      this.main.Controller.Reachability.inpStation.validateLocation(true, Hafas.bind(function () {
        data.shift();
        if (data.length > 0) {
          this.main.Controller.Reachability.validate(data, callback);
        } else {
          callback();
        }
      }, this));
    } else {
      data.shift();
      if (data.length > 0) {
        this.main.Controller.Reachability.validate(data, callback);
      } else {
        callback();
      }
    }
    return false;
  },
  searchFromMapPosition: function (data) {
    var toolboxButton = Hafas('[data-proximity-toolbox="button"]', false);
    var toolboxSpinner = Hafas('[data-proximity-toolbox="spinner"]', false);
    if (toolboxSpinner) {
      Hafas.Util.gui.setVisibility(toolboxSpinner, true);
    }
    if (toolboxButton) {
      Hafas.Util.gui.setVisibility(toolboxButton, false);
    }
    // Nur für Desktop & Tablet relevant
    if (!Hafas('#HFS_WebApp').classList.contains('layout-small')) {
      // Mantis-Task: #0069343: Flyoutfunktion: Erreichbarkeitssuche sollte entsprechenden Tab öffnen
      Hafas.ps.pub('/app/switchContext', [{
        context: 'Reachability',
        method: 'index',
        backJumpTarget: data.backJumpTarget || null
      }]);
    }
    this.Controller.Reachability.instance.setLocation(data.location);
    this.Controller.Reachability.instance.startSearch();
  },
  setLocation: function (loc) {
    this.Controller.Reachability.instance.setLocation(loc);
    //this.Controller.Proximity.instance.startSearch();
  },
  startSearch: function (data) {
    this.Controller.Reachability.instance.startSearch();
    if (data.form.elements.submitReachabilityForm) {
      Hafas.bind(this.Controller.App.triggerLoadingImage, this)(data.form.elements.submitReachabilityForm);
    }
  },
  hideResult: function () {
    this.Controller.Reachability.instance.hide();
  },
  changePeriod: function (period) {
    var selectedValue = period;
    var intValue = parseInt(selectedValue);
    this.Controller.Reachability.instance.setPeriod(intValue);
    // Track
    var _me = this;
    Hafas.ps.pub('/tracking/event/proximity-settings-period', ['[' + _me.appContext + '] PERIOD: ' + intValue])
  },
  changeMode: function (data) {
    var selectBox = data.source;
    var selectedValue = data.source.options[data.source.selectedIndex].value;
    if (selectedValue == 'out') {
      this.Controller.Reachability.instance.setFrwd(true);
    } else {
      this.Controller.Reachability.instance.setFrwd(false);
    }
  },
  changeDay: function (data) {
    var selectBox = data.source;
    var selectedValue = data.source.options[data.source.selectedIndex].value;
    var hciDate = this.Controller.Proximity.instance.getNextDay(selectedValue);
    this.Controller.Proximity.instance.setRequestDate(hciDate);
  },
  showResult: function (data) {
    // remove loadingImage
    var me = this;
    if (me.trigger) {
      if (me.triggerLoadingImage) {
        try {
          me.trigger.removeChild(me.triggerLoadingImage);
          delete me.triggerLoadingImage;
        } catch (e) {
          // do nothing
        }
      }
      me.trigger.removeAttribute('disabled');
    }
    if (this.layoutClass == 'small') {
      Hafas.ps.pub('/GUI/map/show', [{trigger: this, ev: {}, template: 'Common_MapPageHeaderConnection'}]);
    }
    Hafas.bind(this.Controller.Reachability.addToSearchHistory,this)();
  },
  addToSearchHistory: function(){
    var reachLoc = this.Controller.Reachability.instance.getLocation();
    reachLoc.prod = Hafas.Modules.Suggest.getSuggestInstanceById('ReachabilityLocation').productRef;
    this.Controller.Favorites.instance.addLocation(reachLoc, 'History');
    Hafas.ps.pub('/favorites/update');
  },
  updateLocationDisplay: function (loc) {
    var inputField = Hafas('#ReachabilityLocation', false);
    if (!inputField) {
      return;
    }

    if (loc != null) {
      inputField.value = loc.name;
    } else {
      inputField.value = '';
    }
  },
  changeDisplayMode: function (data) {
    // Vorübergehend so realisiert, bis Options Module direkte Übergabe der ausgewählten Werte unterstützt
    var selectBox = data.source;
    var selectedValue = data.source.options[data.source.selectedIndex].value;
    if (selectedValue == 1) {
      this.Controller.Reachability.instance.setColorMode('Colored');
    } else {
      this.Controller.Reachability.instance.setColorMode('BlackWhite');
    }
  },
  selectProduct: function (cls, boolval) {
    this.Controller.Reachability.instance.setProductClass(parseInt(cls, 10), boolval);
  },
  showErrorHint: function (proximityInstance) {
    var errorDomElem = Hafas('[data-error-hint="proximityNoResults"]', false);
    if (errorDomElem) {
      Hafas.Util.gui.setVisibility(errorDomElem, true);
      Hafas.ps.pub('/app/events/resize');
    }
  },
  hideErrorHint: function () {
    var errorDomElem = Hafas('[data-error-hint="proximityNoResults"]', false);
    if (errorDomElem) {
      Hafas.Util.gui.setVisibility(errorDomElem, false);
      Hafas.ps.pub('/app/events/resize');
    }
  },
  cleanup: function () {
    var me = this;
    Hafas.bind(me.Controller.Reachability.hideResult, me)();
    Hafas.ps.pub('/GUI/form/hide', [{}]);
    Hafas.ps.pub("/map/closeAllToolboxItems", [])
  },

  closeView: function (histData) {
    var me = this;
    Hafas.bind(me.Controller.Reachability.cleanup, me)();
    switch (histData.view) {
      case "index":
        Hafas.ps.pub('/GUI/form/hide', [{}]);
        break;
      case "options":
        Hafas.ps.pub('/GUI/form/show', [{}]);
        Hafas.ps.pub('/options/gui/toggle', [{target: 'HFS_CustomerOptionsWrap', open: false, view: 'options'}]);
        break;
      case "optionsDetails":
        histData.data.open = false;
        Hafas.ps.pub('/options/gui/toggle/group', [{groupId: 'HFS_ReachProductOptions', target: 'HFS_ReachProductOptions_Panel', view: 'optionsDetails', open: false}]);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/hide', []);
        break;
    }
  },

  restoreView: function (histData) {
    var me = this;
    var view = histData.view;
    switch (view) {
      case "index":
        Hafas.bind(me.Controller.Reachability.index, me)();
        break;
      case "options":
        Hafas.ps.pub('/GUI/form/show', [{appcontext: 'Reachability'}]);
        Hafas.ps.pub('/options/gui/toggle', [{target: 'HFS_CustomerOptionsWrap', open: true, view: 'options'}]);
        break;
      case "optionsDetails":
        Hafas.ps.pub('/GUI/form/show', [{}]);
        Hafas.ps.pub('/options/gui/toggle', [{open: true}]);
        histData.data.open = true;
        Hafas.ps.pub('/GUI/options/details/toggle', [histData.data]);
        break;
    }
  }
};
